import { formatPesoAmount } from './money';

// Use the sale's saved promotion, so historical vouchers never depend on the
// current catalog or recalculate which offer would apply today.
const getReceiptPromotionLines = (item) => {
    const snapshot = item?.promotionSnapshot;
    const quantity = (value) => Number(value).toLocaleString('es-CL', { maximumFractionDigits: 3 });
    if (snapshot?.kind === 'temporary_price') {
        if (Number(snapshot.weightPriceId) > 0 && Number(snapshot.minimumWeight) > 0
            && snapshot.weightPromotionPrice != null && Number.isFinite(Number(snapshot.weightPromotionPrice))) {
            const minimum = quantity(snapshot.minimumWeight);
            const price = Number(snapshot.weightPromotionPrice);
            const lines = [
                `Promoción: ${minimum} kg por $${formatPesoAmount(price)}`,
                `Desde ${minimum} kg: $${formatPesoAmount(price / Number(snapshot.minimumWeight))}/kg`,
            ];
            if (Number(snapshot.qualifyingWeight) > Number(item.quantity)) {
                lines.push(`Peso acumulado: ${quantity(snapshot.qualifyingWeight)} kg`);
            }
            return lines;
        }
        const pack = Number(snapshot.packPriceId) > 0 && Number(snapshot.packQuantity) > 0
            ? snapshot.segments?.find((segment) => Number(segment.quantity) === Number(snapshot.packQuantity)) : null;
        if (pack?.price != null && Number.isFinite(Number(pack.price))) {
            return [`Promoción: ${quantity(snapshot.packQuantity)} por $${formatPesoAmount(pack.price)}`];
        }
        return [`Temporal: ${item.promotionName || 'Precio temporal'}`];
    }
    if (snapshot?.kind === 'format_offer' && Number(snapshot.formatOfferId) > 0) {
        return [item.promotionName ? `Oferta: ${item.promotionName}` : 'Oferta aplicada'];
    }
    if (item?.promotionName && (Number(item.promotionId) > 0 || item.discountSource === 'promotion')) {
        return [`Promoción: ${item.promotionName}`];
    }
    return [];
};

export { getReceiptPromotionLines };
